// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { ProductTypeTagMap } from './product-type-tag-map';
import { Supplier } from './supplier';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ProductTypeTag extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** String(200) */
  apiLink?: string;
  /** String(60) */
  name!: string;
  /** Binary */
  rowVersion!: any;
  /** Guid FK supplier */
  supplierId!: string;
  /** Inv FK productTypeTagId */
  productTypeTagMaps!: ProductTypeTagMap[];
  /** FK supplierId */
  supplier!: Supplier;
}

